import type { Strings } from '../FooterFlags';

import STYLES from './FooterFlagOption.module.scss';

type FooterFlagOptionProps = {
  dropDownItemLabel: Strings['selectedOptionLabel'];
  url: string;
};

const FooterFlagOption = ({ dropDownItemLabel, url }: FooterFlagOptionProps) => (
  <option className={STYLES.FooterFlagOption} value={url}>
    {dropDownItemLabel}
  </option>
);

export default FooterFlagOption;
